import { ExpensesDateTimeRangeFormFragment } from 'generated/resources/graphql'

export const getDateTimeRangeAttributes = (data: ExpensesDateTimeRangeFormFragment) => {
  return {
    start_date: data.perDiem?.startDate ?? null,
    end_date: data.perDiem?.endDate ?? null,
  }
}
